var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FF6A61"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.293 19.315v4.393h15.415v-4.393c0-.633.513-1.146 1.146-1.146.633 0 1.146.513 1.146 1.146v4.542C26 25.04 25.039 26 23.857 26H8.143C6.962 26 6 25.039 6 23.857v-4.542c0-.633.514-1.146 1.147-1.146.632 0 1.146.513 1.146 1.146z",
    transform: "translate(-488 -251) translate(488 251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.81 19.547l4.703-4.702c.447-.448.447-1.174 0-1.622-.447-.448-1.174-.448-1.621 0l-2.707 2.708V7.146c0-.633-.513-1.146-1.146-1.146-.633 0-1.146.513-1.146 1.146v8.862l-2.783-2.785c-.448-.448-1.174-.448-1.622 0-.224.224-.336.518-.336.811 0 .293.112.587.336.811l4.702 4.702c.215.215.506.336.81.336.305 0 .596-.12.81-.336z",
    transform: "translate(-488 -251) translate(488 251) matrix(1 0 0 -1 0 25.883)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUpload);
export default __webpack_public_path__ + "static/media/ico-upload.a936288ae79bc299ae192d93650a9bd4.svg";
export { ForwardRef as ReactComponent };